import React, { useState } from 'react';
import TextField from '@material-ui/core/TextField';

const LiveTextInput = (props) => {
    const {onAnswer, questionIndex} = props;
    const [liveValue, setLiveValue] = useState('');

    const onChange = (event) => {
        setLiveValue(event.target.value);
        if (onAnswer) {
            onAnswer(event.target.value, questionIndex);
        }
    }

    return <TextField
        margin="dense"
        helperText="User inputs answer here"
        type="text"
        fullWidth
        value={liveValue}
        onChange={onChange}
    />
}

export default LiveTextInput;